<template>
  <div class="payment-method">
    <div class="dashboard-form-row" @click="updatePaymentMethod('credit_card')">
      <span class="keyboard-checkbox__input dashboard-form-input">
        <input
          :class="[isSelected('credit_card') && 'keyboard-checkbox--checked']"
          type="radio"
          name="card - checkbox"
          :checked="isSelected('credit_card')"
        />
        <span
          :class="
            `keyboard-checkbox__control keyboard-checkbox__control--radio`
          "
        >
          <span
            v-show="isSelected('credit_card')"
            class="keyboard-checkbox__radio-dot"
        /></span>
      </span>
      <label class="keyboard-checkbox dashboard-form-checkbox">
        <div class="keyboard-checkbox__text">
          <span class="keyboard-selection__flag dashboard-form-input-label"
            >Credit Card
          </span>
        </div>
      </label>
    </div>
    <div
      class="dashboard-form-row"
      @click="updatePaymentMethod('paypal_billing_agreement')"
    >
      <span class="keyboard-checkbox__input dashboard-form-input">
        <input
          :class="[
            isSelected('paypal_billing_agreement') &&
              'keyboard-checkbox--checked',
          ]"
          type="radio"
          name="paypal - checkbox"
          :checked="isSelected('paypal_billing_agreement')"
        />
        <span
          :class="
            `keyboard-checkbox__control keyboard-checkbox__control--radio`
          "
        >
          <span
            v-show="isSelected('paypal_billing_agreement')"
            class="keyboard-checkbox__radio-dot"
        /></span>
      </span>
      <label class="keyboard-checkbox dashboard-form-checkbox">
        <div class="keyboard-checkbox__text">
          <span class="keyboard-selection__flag dashboard-form-input-label"
            >Paypal
          </span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethod',
  props: {
    paymentMethod: {
      type: String,
      required: true,
    },
  },
  methods: {
    isSelected(method) {
      return method === this.paymentMethod
    },
    updatePaymentMethod(method) {
      this.$emit('update-payment-method', method)
    },
  },
}
</script>

<style lang="scss">
.payment-method {
  margin-bottom: 50px;
  @include mobile {
    width: 135px;
    min-width: 174px;
    margin-bottom: 0;
  }
}
</style>
